import { createI18n } from 'vue-i18n'
const i18n = createI18n({
  locale: 'en',
  messages: {
    'en': {
      
    },
    'ar': {
      'Contact Us': 'تواصل معنا',
      'Contact information': 'معلومات الاتصال',
      'Home':'الرئيسية',
      'About':'عن المؤتمر',
      'Agenda':'أجندة المؤتمر',
      'Speakers':'المتحدثون',
      'Research':'البحوث',
      'Media library':'مكتبة الوسائط',
      'Highlights':'أبرز الأحداث',
      'FAQs':'الأسئلة الشائعة',
      'Get in touch':'تواصل معنا',
      'Quick links':'روابط سريعة',
      'Resources':'الموارد',
      'Your browser does not support the video tag.': 'متصفحك لا يدعم علامة الفيديو.',
      'Watch Live':'شاهد مباشرة',
      'DAYS':'أيام',
      'HOURS':'ساعات',
      'MINUTES':'دقائق',
      'SECONDS':'ثواني',
      'Download Full Agenda':'تحميل الأجندة الكاملة',
      'Read More':'اقرأ المزيد',
      'Date':'التاريخ',
      'No articles found.':'لا توجد مقالات.',
      'By':'بواسطة',
      'Full Name':'الاسم الكامل',
      'Email':'البريد الإلكتروني',
      'Subject':'الموضوع',
      'Message':'الرسالة',
      'Send message':'إرسال الرسالة',
      'Please enter your full name.':'يرجى إدخال اسمك الكامل',
      'Please enter your email.':'يرجى إدخال بريدك الإلكتروني',
      'Please enter a valid email address.':'يرجى إدخال عنوان بريد إلكتروني صالح',
      'Please enter subject.':'يرجى إدخال الموضوع',
      'Please enter your message.':'يرجى إدخال رسالتك',
      'Follow Us':'تابعنا',
      'Search articles...':'ابحث في المقالات...',
      'Position':'المنصب',
      'Organization':'المنظمة',
      'Bio':'السيرة الذاتية',
      'View Bio':'السيرة الذاتية',
      'Close':'إغلاق',
      'Speaker Details':'تفاصيل المتحدث',
      'Page Not Found':'الصفحة غير موجودة',
      'Sorry, the page you are looking for does not exist.':'عذرًا، الصفحة التي تبحث عنها غير موجودة.',
      'Back to Home':'العودة إلى الرئيسية',
      'Check Agenda':'عرض الأجندة',
      'Load More':'المزيد',
      'No images available':'لا توجد صور متاحة',
      'Add Question':'أضف سؤال',
      'Add your question here':'أضف سؤالك هنا',
      'See More':'عرض المزيد',
      'AlUla Experience Guide 2026 - Click here to download':'دليل تجربة العلا 2026 – اضغط هنا للتنزيل',
      'Question is required.':'الرجاء إدخال السؤال.',
      'Question submitted successfully!':'تم إرسال السؤال بنجاح!',
      'Please enter a valid email address.':'يرجى إدخال عنوان بريد إلكتروني صالح',
      'Full Name is required.':'الرجاء إدخال الاسم الكامل',
      'Email is required.':'الرجاء إدخال البريد الإلكتروني',
      'Please fill in your details to submit your question.': 'يرجى ملء المعلومات الأساسية .',
      'Please Fill the missing information then submit the question again':'يرجى ملء المعلومات الناقصة ثم إعادة إرسال السؤال',
      'Visitor Details':'تفاصيل الزائر',
      'Continue':'استمرار',
      'Share':'مشاركة',
      'Media Partners':'شركاء الإعلام',
      '':'',
      '':'',


    },
  },
})
export default i18n

